<h1 class="areaHeading pt-5 pb-2 mt-5">Contact</h1>
<div class="row">
  <div class="col-md-12">
    <div class="row">
      <div class="col-md-12 col-lg-7 col-xl-7 mb-3">

        <div class="card contact_container">
          <ng-container *ngIf="loading; then loadingBlock; else formBlock"></ng-container>
          <ng-template #loadingBlock>
            <img src="../../../../assets/img/svg/loading.svg" alt="loading" height="250px">
            <div class="stage">
              <div class="dot-floating"></div>
            </div>
            <p style="text-align: center;">
              Submitting your response
            </p>
          </ng-template>
          <ng-template #formBlock>
            <ng-container *ngIf="responseRecevied; then successBlock; else contactFormBlock"></ng-container>
            <ng-template #successBlock>
              <div style="text-align: center;">
                <img src="../../../../assets/img/svg/success.jpg" alt="loading" height="250px">
                <p style="margin-bottom: 10px;">
                  Response sent!
                </p>
                <button mat-button color="primary" class="another_response" (click)="anotherResponse()">
                  Submit another response
                </button>
              </div>

            </ng-template>
            <ng-template #contactFormBlock>
              <div style="width: 100%;">
                <h1 style="font-weight: 500; letter-spacing: 0.01rem; margin-bottom: 5px;">
                  Get in touch
                </h1>
                <p style="padding-left: 2px; font-weight: 400;">
                  I would love to hear from you!
                </p>
              </div>

              <form (ngSubmit)="onSubmit(contactForm.value)" [formGroup]="contactForm">

                <div class="row">
                  <div class="col-md-6">
                    <mat-form-field style="width: 100%;" appearance="outline">
                      <mat-label style="font-size: 15px;" for="firstname">First name</mat-label>
                      <input matInput placeholder="John" id="firstname" type="text" formControlName="firstname"
                        required />
                    </mat-form-field>
                  </div>
                  <div class="col-md-6">
                    <mat-form-field style="width: 100%;" appearance="outline">
                      <mat-label style="font-size: 15px;" for="lastname">Last name</mat-label>
                      <input matInput placeholder="Doe" id="lastname" type="text" formControlName="lastname" required />
                    </mat-form-field>
                  </div>
                </div>

                <div class="row">
                  <div class="col-md-12">
                    <mat-form-field style="width: 100%;" appearance="outline">
                      <mat-label style="font-size: 15px;" for="email">Email</mat-label>
                      <input matInput placeholder="Ex. john.doe@gmail.com" type="email" id="email"
                        formControlName="email" required />
                    </mat-form-field>
                  </div>
                </div>


                <div class="row">
                  <div class="col-md-12 mb-2">
                    <mat-form-field style="width: 100%;" appearance="outline">
                      <mat-label style="font-size: 15px;">Leave a comment</mat-label>
                      <textarea matInput placeholder="Ex. It makes me feel..." rows="4" id="comments"
                        formControlName="comment" #comment required></textarea>
                      <mat-hint align="end">{{comment.value.length}} / 300</mat-hint>
                    </mat-form-field>
                  </div>
                </div>

                <button mat-raised-button type="submit" color="primary" [disabled]="contactForm.invalid">
                  Send Message <mat-icon>trending_flat</mat-icon>
                </button>

              </form>

            </ng-template>
          </ng-template>

        </div>

        <!-- <div class="card contactCardPadding card-update"
          [ngClass]=" { 'beforeLogin' : !loggedIn, 'afterLogin': loggedIn, 'top-p': !loggedIn } ">
          <h1 class="text-center txt-primary"> Hey There, happy to hear from you. </h1>
          <form *ngIf="loggedIn" class="example-form" [formGroup]="contactForm"
            (ngSubmit)="onSubmit(contactForm.value)">
            <br>
            <div class="post-container">
              <div class="post-thumb">
                <img [src]='loggedInUserPhoto' [alt]="loggedInUserName" width="80" height="80"
                  style="border-radius: 50%;" />
              </div>
              <div class="post-content">
                <input type="text" class="bk-primary" style="border: none; font-weight: 500; font-size: 20px;"
                  formControlName="userName" readonly>
                <br>
                <input type="text" class="bk-primary" style="border: none;" formControlName="userEmail" readonly>
              </div>
            </div>
            <br>
            <mat-form-field style="width: 100%;">
              <mat-label style="font-size: 15px;">Leave a comment</mat-label>
              <textarea matInput placeholder="Ex. It makes me feel..." rows="4" id="comments"
                formControlName="userComment" required></textarea>
            </mat-form-field>
            <br>
            <br>
            <button class="btn" type="submit">Submit</button>
          </form>
          <div *ngIf="!loggedIn" style="height: inherit;" class="py-5 px-3">
            <a class="btn" style="background-color: white; width: unset; display: block; padding: 5%; padding-top: 3%;"
              (click)="this.auth.googleSignin()">
              <i class="fa fa-google" aria-hidden="true" style="font-size: 8rem;"></i>
              <h1 class="pt-4" style="word-spacing: 0.1rem; word-spacing: 0.19rem;">
                Sign In with Google
              </h1>
            </a>
            <br> <br>
            <a *ngIf="false" class="btn" style="background-color: white; width: unset;  display: block;"> <i
                class="fa fa-facebook" style="color: #4267B2;" aria-hidden="true"></i> &nbsp; Facebook Login
            </a>
          </div>
        </div> -->
      </div>
      <div class="col-md-12 col-lg-5 col-xl-5 mb-3 text-center">
        <iframe title="Contact Location"
          src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d178787.81912808729!2d-73.71187334999999!3d45.5591827!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x4cc91a541c64b70d%3A0x654e3138211fefef!2sMontreal%2C%20QC!5e0!3m2!1sen!2sca!4v1705955349647!5m2!1sen!2sca"
          width="100%" height="450" frameborder="0" style="border:0;" allowfullscreen="true" aria-hidden="false"
          tabindex="0"
          style="padding: 0%; margin: 0; box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.1), 0 3px 10px 0 rgba(0, 0, 0, 0.09); pointer-events: none;"></iframe>
      </div>
    </div>
  </div>
</div>
